export default __webpack_public_path__ + "static/media/ai-btn.9641c8a1.png";